module.exports = __webpack_public_path__ + "img/2 (10).09477022.jpg";